import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import EnImages from '../views/en-images/EnImages.vue'
import Labels from '../views/labels/Labels.vue'
import EcoResponsabilite from '../views/labels/EcoResponsabilite.vue'
import InnovationsServices from '../views/labels/InnovationsServices.vue'
import Acteurs from '../views/acteurs/Acteurs.vue'
import Architectes from '../views/acteurs/Architectes.vue'
import Maquette from '../views/maquette/Maquette.vue'
import LeQuartier from '../views/quartier/LeQuartier.vue'
import Appartement from '../views/appartement/Appartement.vue'
import VotreInterieur from '../views/appartement/VotreInterieur.vue'
import VosExterieurs from '../views/appartement/VosExterieurs.vue'
import LesPrestations from '../views/appartement/LesPrestations.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  // LA RESIDENCE
  {
    path: '/la-residence-en-images',
    name: 'EnImages',
    component: EnImages
  },
  // LABELS
  {
    path: '/labels-innovations-et-services',
    name: 'Labels',
    component: Labels
  },
  {
    path: '/labels-et-eco-responsabilite',
    name: 'EcoResponsabilite',
    component: EcoResponsabilite
  },
  {
    path: '/innovations-et-services',
    name: 'InnovationsServices',
    component: InnovationsServices
  },
  /* LES ACTEURS DU PROJET*/
  {
    path: '/les-acteurs-du-projet',
    name: 'Acteurs',
    component: Acteurs
  },
  {
    path: '/le-mot-des-architectes',
    name: 'Architectes',
    component: Architectes
  },
  /* Maquette orbitale*/
  {
    path: '/maquette-orbitale',
    name: 'Maquette',
    component: Maquette
  },
  /* LE QUARTIER*/
  {
    path: '/le-quartier',
    name: 'LeQuartier',
    component: LeQuartier
  },
  /* APPARTEMENT*/
  {
    path: '/appartement',
    name: 'Appartement',
    component: Appartement
  },
  {
    path: '/votre-interieur',
    name: 'VotreInterieur',
    component: VotreInterieur
  },
  {
    path: '/vos-exterieurs',
    name: 'VosExterieurs',
    component: VosExterieurs
  },
  {
    path: '/les-prestations',
    name: 'LesPrestations',
    component: LesPrestations
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
